import { render } from "./Cal2.vue?vue&type=template&id=e0e6b63c"
const script = {}

import exportComponent from "/opt/buildhome/repo/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.22_vue@3.5.22_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__